import { Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import './ammunition.scss'
import { ICommonQuery, IPageHeaderActions } from '@Models/common.model'
import { MAmmunition } from '@Models/client/ammunition.model'
import { APIServices } from '@Services/api.service'
import DetailAmmunitionModal from '@Pages/Client/ammunition/DetailAmmunitionModal'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
// import AmmunitionBox from '@Components/Box/AmmunitionBox/AmmunitionBox'
import ClientAmmunitionActions from '@Stores/client/actions/ammunition.action'
import CustomTabs from '@Components/CustomTabs/CustomTabs/CustomTabs'
import TabPanel from '@Components/CustomTabs/TabPanel/TabPanel'
import AmmunitionBox from '../../../components/Box/AmmunitionBox/AmmunitionBox'
import AddAmmunitionModal from './AddAmmunitionModal'

// dummy data
const headerActions: IPageHeaderActions[] = [
    {
        name: 'Add Ammunition',
        value: 'add-ammunition',
    },
]

const tabs = ['Ammunition', 'Dispute Purchase']

// models section
interface IAmmunition {
    // redux
    getAmmunition: (params?: ICommonQuery) => void
    ammunition: MAmmunition[]
}

function Ammunition(props: IAmmunition) {
    // core section
    const { getAmmunition, ammunition } = props

    // states section
    const [showAmmunitionDetail, setShowAmmunitionDetail] = useState(false)
    const [showAddAmmunition, setShowAddAmmunition] = useState(false)
    const [ammunitionDetail, setAmmunitionDetail] = useState<any>()
    const [tab, setTab] = useState(0)

    // hooks section
    /**
     * get data from API when first load
     */
    useEffect(() => {
        getAmmunition()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    // functions section
    /**
     * perform action click
     * @param value get from header component
     */
    const onHandleActions = (action: string) => {
        setShowAddAmmunition(true)
    }

    /**
     * handle ammunition click event
     * @param ammunitionEvent ammunition object from ammunition box component
     */
    const handleAmmunitionClicked = (ammunitionEvent: any) => {
        const ammunitionData = ammunitionEvent?.ammunition
        setAmmunitionDetail(ammunitionData)
        setShowAmmunitionDetail(true)
    }

    const handleTabChange = (
        event: React.ChangeEvent<any>,
        newValue: number
    ) => {
        setTab(newValue)
    }

    // main section
    return (
        <div className="page-ammunition page-custom-tabs">
            {/* add ammunition modal */}
            <AddAmmunitionModal
                open={showAddAmmunition}
                onClose={() => setShowAddAmmunition(false)}
            />

            {/* detail ammunition modal */}
            <DetailAmmunitionModal
                open={showAmmunitionDetail}
                onClose={() => setShowAmmunitionDetail(false)}
                data={ammunitionDetail}
            />

            <PageHeader
                title="Ammunition"
                // actions={headerActions}
                // getActions={(e: any) => onHandleActions(e)}
            />
            <CustomTabs tabs={tabs} value={tab} onChange={handleTabChange} />
            <TabPanel value={tab} index={0}>
                <Grid container spacing={3}>
                    {ammunition?.map(
                        (
                            ammunitionItem: MAmmunition,
                            ammunitionIndex: number
                        ) => {
                            return (
                                <Grid
                                    item
                                    sm={6}
                                    xs={12}
                                    key={`${
                                        ammunitionItem?.madeAt
                                    }_ammunition_${+ammunitionIndex}`}
                                >
                                    <AmmunitionBox
                                        ammunition={ammunitionItem}
                                        addAction={handleAmmunitionClicked}
                                    />
                                </Grid>
                            )
                        }
                    )}
                </Grid>
            </TabPanel>
            {/* <TabPanel value={tab} index={1}>
                <p>Dispute Purchase</p>
            </TabPanel> */}
        </div>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { ammunition } = store?.client?.ammunition
    return {
        ammunition,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getAmmunition } = ClientAmmunitionActions
    return {
        getAmmunition: (params?: ICommonQuery) =>
            dispatch(getAmmunition(params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Ammunition)
